import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreateAlmacen = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/almacenes`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearAlmacenMutation: mutation.mutate,
    };
}